export type SessionUser = {
  id: string;
  username: string;
};

class APIError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "APIError";
    this.status = status;
  }
}

const request = async <T>(
  input: string,
  init?: RequestInit,
  opts?: { allowNotFound?: boolean },
): Promise<T> => {
  const response = await fetch(input, {
    ...init,
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers || {}),
    },
  });

  if (opts?.allowNotFound && response.status === 404) {
    return { user: null } as T;
  }

  let payload: any = {};

  try {
    payload = await response.json();
  } catch (error) {
    payload = {};
  }

  if (!response.ok) {
    throw new APIError(payload.error || "Request failed", response.status);
  }

  return payload as T;
};

export const getSessionUser = async () => {
  const response = await request<{ user: SessionUser | null }>(
    "/api/auth/session",
    { method: "GET" },
    { allowNotFound: true },
  );

  return response.user;
};

export const registerUser = async (username: string, password: string) => {
  const response = await request<{ user: SessionUser }>("/api/auth/register", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });

  return response.user;
};

export const loginUser = async (username: string, password: string) => {
  const response = await request<{ user: SessionUser }>("/api/auth/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });

  return response.user;
};

export const logoutUser = async () => {
  await request<{ ok: true }>("/api/auth/logout", {
    method: "POST",
    body: JSON.stringify({}),
  });
};
